"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatencyResult = void 0;
var LatencyResult;
(function (LatencyResult) {
    LatencyResult["MET"] = "MET";
    LatencyResult["EXCEEDED"] = "EXCEEDED";
    LatencyResult["UNUSED"] = "UNUSED";
})(LatencyResult = exports.LatencyResult || (exports.LatencyResult = {}));
